import { render, staticRenderFns } from "./DateNotificationCTM.vue?vue&type=template&id=0b0746a0"
import script from "./DateNotificationCTM.vue?vue&type=script&lang=js"
export * from "./DateNotificationCTM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports